import momentVi from 'moment/locale/vi';
import merchantIp from './vi/merchantip';
import transactionRecord from './vi/transactionRecord';
import transaction from './vi/transaction';
import userTransaction from './vi/userTransaction';
import withdrawBank from './vi/withdrawBank';
import home from './vi/home';
import btns from './vi/btns';
import status from './vi/status';
import withdraw from './vi/withdraw';
import merchantdeposit from './vi/merchantdeposit.js';
import passwd from './vi/passwd';
import login from './vi/login';
import clientmanage from './vi/clientmanage';
import channel from './vi/channel';
import wallet from './vi/walletRecord';
import orders from './vi/orders';
import accountmanager from './vi/accountmanager';
import menumanage from './vi/menumanage';
import merchantBalance from './vi/merchantBalance';
import rolemanager from './vi/rolemanager';
import merchantdetails from './vi/merchantdetails';
import welcome from './vi/welcome';
import channelTest from './vi/channelTest';
import momoLogs from './vi/momoLogs';
import usdt from './vi/usdt';
import sysConfig from './vi/sysConfig';
import device from './vi/device';
import channelList from './vi/channelList';

const components = {
  momentName: 'Vi',
  momentLocale: momentVi
};

const langs = {
  /* -------------------------------------------------------------------------- */
  /*                              @NOTE global 全局翻译                             */
  tips: {
    tip1: 'xác nhận muốn xoá không？',
    tip2: 'Bạn có đơn rút tiền mới {money} VND',
    tip3: 'Bạn có đơn nạp tiền mới {money}  VND'
  },
  btns,
  status,
  /*                              @NOTE global 全局翻译                             */
  /* -------------------------------------------------------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                                @NOTE 页面翻译文件                                */
  momoLogs,
  merchantIp,
  transaction,
  transactionRecord,
  userTransaction,
  withdrawBank,
  withdraw,
  merchantdeposit,
  passwd,
  clientmanage,
  login,
  home,
  channel,
  orders,
  wallet,
  accountmanager,
  menumanage,
  rolemanager,
  merchantdetails,
  merchantBalance,
  welcome,
  channelTest,
  usdt,
  sysConfig,
  device,
  channelList
  /*                                @NOTE 页面翻译文件                                */
  /* -------------------------------------------------------------------------- */
};

export default { ...langs, ...components };



// WEBPACK FOOTER //
// ./src/i18n/lang/vi.js